import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({

    textCenter: {
        textAlign: 'center'
    },
    iconRight: {
        marginLeft: theme.spacing(1)
    },
    iconLeft: {
        marginRight: theme.spacing(1)
    },

    form: {
        paddingBottom: theme.spacing(8)
    },
    errorInput: {
        backgroundColor: 'rgb(250,128,114)',
    },
    menuItem: {
        '&.Mui-selected': {
            backgroundColor: 'rgb(144, 238, 144) !important', // Format RGB yang benar
            color: 'black',
        },
        '&.Mui-selected:hover': {
            backgroundColor: 'rgb(152, 251, 152) !important', // Format RGB yang benar
        }
    },
}))


export default useStyles;